import {styled, TextField as MUITextField, TextFieldProps, alpha} from '@mui/material'

export type HPTextFieldProps = TextFieldProps & {backgroundMode?: 'onLight' | 'onDark'}
/**
 * Styled wrapper around MUI TextField component which could be used on light and dark background
 * accepts all MUI TextField props plus backgroundMode prop
 */
export const HPTextField = styled(MUITextField, {
  shouldForwardProp: (prop) => prop !== 'backgroundMode'
})<HPTextFieldProps>(({theme: {palette}, backgroundMode = 'onLight'}) => ({
  // base style override
  '& .MuiInputBase-root': {
    // Background color is set to 0.03 opacity to make it flexible for both light and dark backgrounds
    backgroundColor: alpha(palette.background.default, 0.03),
    ...(backgroundMode === 'onDark'
      ? {
          color: palette.common.white,
          '& .MuiSvgIcon-root': {
            color: palette.common.white
          },
          '& fieldset': {
            borderColor: alpha(palette.common.white, 0.4)
          },
          '&:hover fieldset': {
            borderColor: alpha(palette.common.white, 0.8)
          },
          '&.Mui-focused': {
            color: palette.common.white,
            '& fieldset': {
              borderColor: alpha(palette.common.white, 0.8)
            }
          }
        }
      : {})
  },
  ...(backgroundMode === 'onDark'
    ? {
        '& .MuiInputLabel-root': {
          color: palette.common.white,
          '&.Mui-focused': {
            color: palette.common.white
          }
        }
      }
    : // styles for light background, already configured in HProduceTheme
      {})
}))
